// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAejOxO812jv-EEdfvEt_WqZWZe3AysBLg",
  authDomain: "filezenai.firebaseapp.com",
  projectId: "filezenai",
  storageBucket: "filezenai.firebasestorage.app",
  messagingSenderId: "483919580426",
  appId: "1:483919580426:web:854ea81a1400870d907ef3",
  measurementId: "G-TYY9KRKPLD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, 'us-central1');

// Export the Firebase services
export { app, analytics, auth, db, storage, functions }; 